import { colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(
  (theme) => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      borderBottom: `1px solid ${colorSet.gray200}`,
      marginBottom: 24,
      [theme.breakpoints.down('xs')]: {
        marginBottom: 0
      }
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: 6
      }
    },
    contents: {
      display: 'flex',
      alignItems: 'center',
      padding: '20px 0px 24px'
    },
    half: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: 'calc(100% / 2)',
      '& .inner_box': {
        height: 96,
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        '& .rating': {
          display: 'flex',
          alignItems: 'center'
        },
        '&.ratios': {
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          justifyContent: 'inherit',
          '&>:not(:last-child)': {
            marginRight: 16
          }
        },
        '& .max': {
          ...theme.typography.h2,
          fontWeight: '400',
          color: colorSet.gray600
        },
        '& .divider': {
          ...theme.typography.h3,
          fontWeight: '400',
          color: colorSet.gray600
        }
      }
    }
  }),
  {
    classNamePrefix: 'review__rating'
  }
);

export default useStyles;
